



























































































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch
} from '@nuxtjs/composition-api'
import { useApp } from '~/compositions/app'
import { useDeps } from '~/compositions/dependency-container'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { useI18n } from '~/compositions/i18n'
import { useCookies } from '~/compositions/useCookies'
import { FIVE_MINUTES_S } from '~/constants/duration'
import { ANON_GUARD_COOKIE } from '~/constants/anon-guard'
import { vue3Model } from '~/utils/nuxt3-migration'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    continueUrl: {
      type: String,
      default: undefined
    }
  },
  setup(props, { emit }) {
    const cookies = useCookies()
    const { isCar } = useApp()
    const { t } = useI18n()
    const [legacyUrlService] = useDeps(LegacyUrlService)

    const isVisible = ref(isCookieDisabled?.value ? false : props.modelValue)

    watch(
      () => props.modelValue,
      newValue => {
        if (!isCookieDisabled.value) {
          isVisible.value = newValue
        } else if (newValue) {
          // set to true but cookie exists
          handleContinueButtonClick()
        }
      }
    )

    watch(isVisible, newIsVisible => emit('update:modelValue', newIsVisible))

    onMounted(() => {
      if (isCookieDisabled.value && !isVisible.value && props.modelValue) {
        handleContinueButtonClick()
      }
    })

    const isCookieDisabled = computed(() => {
      return cookies.get(ANON_GUARD_COOKIE)
    })

    const website = computed(() => {
      return isCar.value ? 'Car.gr' : 'Plot.gr'
    })

    const registerUrl = computed(() => {
      return legacyUrlService.getRegisterUrl({ gotonext: window.location.href })
    })

    const featuresString = computed(() => {
      const features = [
        t('instant messages::prompt_feature').toLowerCase(),
        t('updates::prompt_feature').toLowerCase()
      ]

      if (isCar.value) {
        features.unshift(t('trades::prompt_feature').toLowerCase())
      }

      return features.join(', ')
    })

    const loginUrl = computed(() => {
      return `${legacyUrlService.getUserLoginUrl()}?gotonext=${
        window.location.href
      }`
    })

    function handleContinueButtonClick() {
      if (!isCookieDisabled.value) {
        cookies.set(ANON_GUARD_COOKIE, 1, { maxAge: FIVE_MINUTES_S })
      }

      if (props.continueUrl) {
        window.location.assign(props.continueUrl)
      } else {
        isVisible.value = false
      }
    }

    return {
      isVisible,
      website,
      registerUrl,
      loginUrl,
      featuresString,
      handleContinueButtonClick
    }
  }
})
